<template>
      <div class="user-check">
        <h2>Check Utente</h2>
        <div v-if="userWarning" class="user-warning">
          {{ userWarning }}
        </div>

        <!-- Step 1: Carica Foto -->
        <div class="step">
          <h3>Step 1: Carica Foto</h3>
          <div class="upload-container">
            <div
              class="upload-dropzone"
              @dragover.prevent
              @drop="onDropImageOne"
              @click="triggerFileInput('one')"
            >
              <p>Trascina qui Foto 1 o clicca per selezionarla</p>
              <input
                type="file"
                accept="image/jpeg,image/png,image/jpg"
                @change="onImageOneSelected"
                hidden
                ref="fileInputOne"
              />
              <div v-if="imageOnePreview" class="preview">
                <img :src="imageOnePreview" alt="Anteprima Foto 1" />
              </div>
            </div>

            <div
              class="upload-dropzone"
              @dragover.prevent
              @drop="onDropImageTwo"
              @click="triggerFileInput('two')"
            >
              <p>Trascina qui Foto 2 o clicca per selezionarla</p>
              <input
                type="file"
                accept="image/jpeg,image/png,image/jpg"
                @change="onImageTwoSelected"
                hidden
                ref="fileInputTwo"
              />
              <div v-if="imageTwoPreview" class="preview">
                <img :src="imageTwoPreview" alt="Anteprima Foto 2" />
              </div>
            </div>

            <div
              class="upload-dropzone"
              @dragover.prevent
              @drop="onDropImageThree"
              @click="triggerFileInput('three')"
            >
              <p>Trascina qui Foto 3 o clicca per selezionarla</p>
              <input
                type="file"
                accept="image/jpeg,image/png"
                @change="onImageThreeSelected"
                hidden
                ref="fileInputThree"
              />
              <div v-if="imageThreePreview" class="preview">
                <img :src="imageThreePreview" alt="Anteprima Foto 3" />
              </div>
            </div>

            <div
              class="upload-dropzone"
              @dragover.prevent
              @drop="onDropImageFour"
              @click="triggerFileInput('four')"
            >
              <p>Trascina qui Foto 4 o clicca per selezionarla</p>
              <input
                type="file"
                accept="image/jpeg,image/png"
                @change="onImageFourSelected"
                hidden
                ref="fileInputFour"
              />
              <div v-if="imageFourPreview" class="preview">
                <img :src="imageFourPreview" alt="Anteprima Foto 4" />
              </div>
            </div>
          </div>
        </div>

        <!-- Step 2: Incolla le Tabelle -->
        <div class="step">
          <h3>Step 2: Incolla le Tabelle</h3>
          <div class="measurement-step">
            <div>
              <label for="measurementOneRaw">Misurazione 1:</label>
              <textarea
                id="measurementOneRaw"
                class="measurement-textarea"
                v-model="measurementOneRaw"
                placeholder="Caratteristica  Valore  Data&#10;Peso  66  06-08-2024&#10;Fianchi  103  06-08-2024"
              ></textarea>
            </div>
            <div>
              <label for="measurementTwoRaw">Misurazione 2:</label>
              <textarea
                id="measurementTwoRaw"
                class="measurement-textarea"
                v-model="measurementTwoRaw"
                placeholder="Caratteristica  Valore  Data&#10;Peso  66  15-10-2024&#10;Fianchi  103  15-10-2024"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="step">
          <h3>Step 3: Associa il programma</h3>
          <div class="select-options">
            <div>
              <label for="checkType">Tipo scheda</label>
              <select id="checkType" v-model="checkType">
                <option value="baseline">Dati iniziali (baseline)</option>
                <option value="progress">Check di andamento</option>
              </select>
            </div>
            <div>
              <label for="percorsoSelect">Programma collegato (opzionale)</label>
              <select id="percorsoSelect" v-model="selectedPercorsoId">
                <option value="">— Nessun programma —</option>
                <option v-for="p in percorsi" :key="p.id" :value="p.id">
                  {{ renderPercorsoLabel(p) }}
                </option>
              </select>
              <small class="muted" v-if="!percorsi.length">Nessun programma disponibile.</small>
            </div>
          </div>
        </div>

        <!-- Step 3: Seleziona Opzioni e Genera Commento 
        <div class="step">
          <h3>Step 3: Seleziona Opzioni e Genera Commento</h3>
          <div class="select-options">
            <div>
              <label for="gender">Utente:</label>
              <select id="gender" v-model="gender">
                <option value="Donna">Donna</option>
                <option value="Uomo">Uomo</option>
              </select>
            </div>
            <div>
              <label for="ageGroup">Età:</label>
              <select id="ageGroup" v-model="ageGroup">
                <option value="Meno di 30">Meno di 30</option>
                <option value="Fra 30 e 40">Fra 30 e 40</option>
                <option value="Fra 40 e 50">Fra 40 e 50</option>
                <option value="Oltre i 50">Oltre i 50</option>
              </select>
            </div>
            <div>
              <label for="menopausa">Sei in menopausa?</label>
              <select id="menopausa" v-model="menopausa">
                <option value="Si">Si</option>
                <option value="No">No</option>
                <option value="Premenopausa">Premenopausa</option>
                <option value="Escludere (uomo)">Escludere (uomo)</option>
              </select>
            </div>
            <div>
              <label for="haSeguito">Ha seguito:</label>
              <select id="haSeguito" v-model="haSeguito">
                <option value="SI">SI</option>
                <option value="NO">NO</option>
              </select>
            </div>
            <div>
              <label for="tipoPercorso">Tipo di percorso:</label>
              <select id="tipoPercorso" v-model="tipoPercorso">
                <option value="solo allenamento">Solo Allenamento</option>
                <option value="solo alimentazione">Solo Alimentazione</option>
                <option value="entrambi">Entrambi</option>
              </select>
            </div>
            <div>
              <label for="haAvutoProgressi">Ha avuto progressi:</label>
              <select id="haAvutoProgressi" v-model="haAvutoProgressi">
                <option value="NO">NO (regredita)</option>
                <option value="SI">SI (migliorata)</option>
                <option value="DA SPRONARE">DA SPRONARE</option>
              </select>
            </div>
<div>
    <label for="respectAllenamento">Allenamento rispettato?</label>
    <select id="respectAllenamento" v-model="respectAllenamento">
      <option value="Si al 100%">Si al 100%</option>
      <option value="solo in parte">Solo in parte</option>
      <option value="No">No</option>
      <option value="Sola Alimentazione">Sola Alimentazione</option>
    </select>
  </div>
<div>
    <label for="respectNutrizione">Alimentazione rispettata?</label>
    <select id="respectNutrizione" v-model="respectNutrizione">
      <option value="Si al 100%">Si al 100%</option>
      <option value="Solo le grammature e non le rotazioni">Solo le grammature e non le rotazioni</option>
      <option value="Ho solo usato gli alimenti ma non li ho pesati">Ho solo usato gli alimenti ma non li ho pesati</option>
      <option value="Ho saltato i pasti">Ho saltato i pasti</option>
      <option value="Ho fatto troppi pasti liberi o inserimenti di cibi extra">Ho fatto troppi pasti liberi o inserimenti di cibi extra</option>
      <option value="Non ho rispettato nulla">Non ho rispettato nulla</option>
      <option value="Solo Allenamento">Solo Allenamento</option>
    </select>
  </div>
            <div>
              <label for="acquaAssunta">Media acqua assunta?</label>
              <select id="acquaAssunta" v-model="acquaAssunta">
                <option value="1">1 L</option>
                <option value="2">2 L</option>
                <option value="3">3 L</option>
                <option value="4">4 L</option>
              </select>
            </div>
            <div>
              <label for="riposoCorretta">Ha riposato correttamente?</label>
              <select id="riposoCorretta" v-model="riposoCorretta">
                <option value="Si">Si</option>
                <option value="No dormo poco e non costantemente">No dormo poco e non costantemente</option>
              </select>
            </div>

            
            <div>
              <label for="periodoStressante">Sta passando un periodo stressante?</label>
              <select id="periodoStressante" v-model="periodoStressante">
                <option value="Si">Si</option>
                <option value="No">No</option>
                <option value="Un po’">Un po’</option>
              </select>
            </div>
            

            <div>
              <label for="integrazione">Ha utilizzato integrazione?</label>
              <select id="integrazione" v-model="integrazione">
                <option value="No">No</option>
                <option value="Si">Si</option>
              </select>
            </div>
          

          </div>
          <button @click="generateComment" :disabled="isGenerating">
            {{ isGenerating ? 'Generazione...' : 'Genera Commento' }}
          </button>
          <div>
            <label for="checkText">Testo generato:</label>
            <textarea
              id="checkText"
              class="check-textarea"
              v-model="checkText"
              placeholder="Il commento generato apparirà qui..."
            ></textarea>
          </div>
        </div>

-->




        <!-- Step 4: Visibilità Profilo
        <div class="step">
          <h3>Step 4: Visibilità Profilo</h3>
          <div class="visibility-toggle">
            <label for="visibilityProfile">Visibile nel profilo?</label>
            <input id="visibilityProfile" type="checkbox" v-model="visibilityProfile" />
          </div>
        </div>
 -->
        
        <!-- Step 5: Salva Check -->
        <div class="step">
          <h3>Step 5: Salva Check</h3>
          <button class="staff-button-positive" @click="saveCheck" :disabled="isLoading">
            {{ isLoading ? 'Salvataggio...' : 'Salva Check' }}
          </button>
        </div>
      </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
import {
  getFirestore,
  collection,
  addDoc,
  doc,
  getDoc,
  serverTimestamp,
  query,
  where,
  onSnapshot
} from 'firebase/firestore';
import { useRouter, onBeforeRouteLeave } from 'vue-router';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';

import { getEnvVar } from '@/lib/env';

export default {
  name: 'UserCheck',
  props: { userId: { type: String, required: true } },
  setup(props) {
    const generateCommentUrl =
      getEnvVar('VITE_FN_GENERATE_CHECK_COMMENT') ||
      getEnvVar('VUE_APP_FN_GENERATE_CHECK_COMMENT') ||
      'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/generateCheckComment';

    // Refs
    const router = useRouter();
    const checkText = ref('');
    const measurementOneRaw = ref('');
    const measurementTwoRaw = ref('');
    const visibilityProfile = ref(true);
    const isLoading = ref(false);
    const isGenerating = ref(false);
    const userWarning = ref('');

    const SPECIAL_UID = '6HPQLWIxnGbTVDYPYCkRZifVxRQ2';
    const SPECIAL_WARNING = 'NON CARICARE LE FOTO PER LEI';

    // Image refs
    const imageOne = ref(null), imageTwo = ref(null), imageThree = ref(null), imageFour = ref(null);
    const imageOnePreview = ref(''), imageTwoPreview = ref(''), imageThreePreview = ref(''), imageFourPreview = ref('');
    const fileInputOne = ref(null), fileInputTwo = ref(null), fileInputThree = ref(null), fileInputFour = ref(null);

    // Select refs
    const gender = ref('Donna');
    const ageGroup = ref('Meno di 30');
    const menopausa = ref('Si');
    const haSeguito = ref('SI');
    const tipoPercorso = ref('entrambi');
    const haAvutoProgressi = ref('SI');
    const respectAllenamento = ref('Si al 100%');
    const respectNutrizione = ref('Si al 100%');
    const acquaAssunta = ref('2');
    const riposoCorretta = ref('Si');
    const percorsi = ref([]);
    const selectedPercorsoId = ref('');
    const checkType = ref('baseline');
    let unsubscribePercorsi = null;
    let autosaveInterval = null;

const STORAGE_KEY = `checkDraft_${props.userId}`;

function saveDraftLocally() {
  const data = {
    checkText: checkText.value,
    measurementOneRaw: measurementOneRaw.value,
    measurementTwoRaw: measurementTwoRaw.value,
    visibilityProfile: visibilityProfile.value,
    gender: gender.value,
    ageGroup: ageGroup.value,
    menopausa: menopausa.value,
    haSeguito: haSeguito.value,
    tipoPercorso: tipoPercorso.value,
    haAvutoProgressi: haAvutoProgressi.value,
    respectAllenamento: respectAllenamento.value,
    respectNutrizione: respectNutrizione.value,
    acquaAssunta: acquaAssunta.value,
    riposoCorretta: riposoCorretta.value,
    selectedPercorsoId: selectedPercorsoId.value,
    checkType: checkType.value
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

function loadDraftLocally() {
  const saved = sessionStorage.getItem(STORAGE_KEY);
  if (!saved) return;
  try {
    const d = JSON.parse(saved);
    checkText.value = d.checkText || '';
    measurementOneRaw.value = d.measurementOneRaw || '';
    measurementTwoRaw.value = d.measurementTwoRaw || '';
    visibilityProfile.value = d.visibilityProfile ?? true;
    gender.value = d.gender || 'Donna';
    ageGroup.value = d.ageGroup || 'Meno di 30';
    menopausa.value = d.menopausa || 'Si';
    haSeguito.value = d.haSeguito || 'SI';
    tipoPercorso.value = d.tipoPercorso || 'entrambi';
    haAvutoProgressi.value = d.haAvutoProgressi || 'SI';
    respectAllenamento.value = d.respectAllenamento || 'Si al 100%';
    respectNutrizione.value = d.respectNutrizione || 'Si al 100%';
    acquaAssunta.value = d.acquaAssunta || '2';
    riposoCorretta.value = d.riposoCorretta || 'Si';
    selectedPercorsoId.value = d.selectedPercorsoId || '';
    checkType.value = d.checkType || 'baseline';
  } catch (e) {
    console.warn('Errore caricando il draft:', e);
  }
}

function warnImageLoss(e) {
  if (imageOne.value || imageTwo.value) {
    e.preventDefault();
    e.returnValue = '';
  }
}

async function loadUserWarning() {
  try {
    const db = getFirestore();
    const userRef = doc(db, 'users', props.userId);
    const snapshot = await getDoc(userRef);
    if (snapshot.exists()) {
      const data = snapshot.data();
      const warningFields = ['checkWarning', 'checkNotice', 'adminWarning'];
      for (const field of warningFields) {
        const value = data?.[field];
        if (typeof value === 'string' && value.trim()) {
          userWarning.value = value.trim();
          return;
        }
      }
    }
  } catch (error) {
    console.error("Errore caricando l'avviso utente:", error);
  }
  if (!userWarning.value && props.userId === SPECIAL_UID) {
    userWarning.value = SPECIAL_WARNING;
  }
}

function subscribePercorsi() {
  if (unsubscribePercorsi) {
    unsubscribePercorsi();
    unsubscribePercorsi = null;
  }
  try {
    const db = getFirestore();
    const percorsiQuery = query(
      collection(db, 'percorsi'),
      where('uid', '==', props.userId)
    );
    unsubscribePercorsi = onSnapshot(
      percorsiQuery,
      (snap) => {
        percorsi.value = snap.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
      },
      (error) => {
        console.error('Errore caricando i percorsi:', error);
        percorsi.value = [];
      }
    );
  } catch (error) {
    console.error('Errore inizializzando i percorsi:', error);
    percorsi.value = [];
  }
}

const renderPercorsoLabel = (p) => {
  if (!p) return 'Programma';
  const parts = [];
  if (p.title) parts.push(p.title);
  else if (p.productName) parts.push(p.productName);
  else parts.push('Programma');
  if (p.sequenceTotal) {
    parts.push(`#${p.sequenceIndex || 1}/${p.sequenceTotal}`);
  }
  return parts.join(' · ');
};

onMounted(() => {
  loadDraftLocally();
  loadUserWarning();
  subscribePercorsi();
  autosaveInterval = setInterval(saveDraftLocally, 5000); // ogni 5 sec
  window.addEventListener('beforeunload', warnImageLoss);
});

watch(
  () => props.userId,
  () => {
    selectedPercorsoId.value = '';
    subscribePercorsi();
  }
);

onBeforeUnmount(() => {
  saveDraftLocally();
  clearInterval(autosaveInterval);
  window.removeEventListener('beforeunload', warnImageLoss);
  if (unsubscribePercorsi) {
    unsubscribePercorsi();
    unsubscribePercorsi = null;
  }
});

onBeforeRouteLeave((to, from, next) => {
  if (imageOne.value || imageTwo.value) {
    if (confirm('⚠️ Hai caricato delle immagini. Cambiando pagina le perderai. Vuoi continuare?')) {
      next();
    } else {
      next(false);
    }
  } else {
    next();
  }
});


    // Parsing e differenze
    function parseMeasurementData(rawData) {
      const lines = rawData.split('\n').map(l => l.trim()).filter(l => l);
      const res = [];
      for (const line of lines) {
        if (/caratteristica/i.test(line) && /valore/i.test(line) && /data/i.test(line)) continue;
        const parts = line.split(/\s{2,}|\t+/);
        if (parts.length>=3) res.push({ caratteristica: parts[0], valore: parts[1], data: parts[2] });
      }
      return res;
    }
    function getMeasurementDifferences(m1, m2) {
      const map1={}, map2={}; m1.forEach(m=> map1[m.caratteristica.toLowerCase()]=parseFloat(m.valore.replace(',', '.')));
      m2.forEach(m=> map2[m.caratteristica.toLowerCase()]=parseFloat(m.valore.replace(',', '.')));
      const keys=Array.from(new Set([...Object.keys(map1),...Object.keys(map2)]));
      let diffText = '';
      keys.forEach(key=>{
        const v1=map1[key], v2=map2[key];
        if(!isNaN(v1)&&!isNaN(v2)){
          const d=v2-v1;
          if(Math.abs(d)<0.001) diffText += `- ${key}: stabile rispetto all'ultima volta.\n`;
          else if(d<0) diffText += `- ${key}: calo di ${Math.abs(d).toFixed(1)} rispetto al check precedente.\n`;
          else diffText += `- ${key}: aumento di ${d.toFixed(1)} rispetto al check precedente.\n`;
        }
      });
      return diffText ? `Differenze misurazioni:\n${diffText}` : 'Nessuna differenza particolare riscontrata o dati insufficienti.\n';
    }
    function completeSentence(text) {
      return /[.!?]\s*$/.test(text) ? text : (text.trimEnd()+'.');
    }

    // Generazione commento
    async function generateComment() {
      try {
        isGenerating.value = true;
        const m1 = parseMeasurementData(measurementOneRaw.value);
        const m2 = parseMeasurementData(measurementTwoRaw.value);
        const diffSummary = getMeasurementDifferences(m1, m2);
        let photoComment = '';
        if(imageOne.value && imageTwo.value) photoComment = 'Dal confronto visivo ... ';
        const selectComment = `
- Utente: ${gender.value}
- Età: ${ageGroup.value}
- Menopausa: ${menopausa.value}
- Ha seguito: ${haSeguito.value}
- Tipo di percorso: ${tipoPercorso.value}
- Ha avuto progressi: ${haAvutoProgressi.value}
- Sedute di allenamento: ${respectAllenamento.value}
- Piano nutrizionale: ${respectNutrizione.value}
- Acqua (litri): ${acquaAssunta.value}
- Riposo: ${riposoCorretta.value}
`;
        const greeting = gender.value==='Donna'?'Ciao cara,':'Ciao caro,';
        const currentMonth = new Date().getMonth()+1;
// invece di const
let styleGuide = `
- Non usare mai la parola "fitness"; sostituiscila con "percorso".
- Evita indicazioni alimentari dettagliate e non menzionare allergie specifiche.
- Tono sempre positivo e motivante.
- Mese attuale: ${currentMonth}, sfrutta il periodo estivo per mantenere la costanza anche durante le ferie.
- Se il peso aumenta ma le circonferenze calano, spiega la possibilità di aumento di massa magra e riduzione di grasso.
- Concludi con una frase motivazionale (es: "Avanti tutta!").
`;

// se è solo allenamento, non citare alimentazione
if (respectNutrizione.value === 'Solo Allenamento') {
  styleGuide += `- Non menzionare l’alimentazione poiché il cliente ha scelto solo allenamento.\n`;
}
// se è sola alimentazione, non citare allenamento
if (respectAllenamento.value === 'Sola Alimentazione') {
  styleGuide += `- Non menzionare l’allenamento poiché il cliente ha scelto sola alimentazione.\n`;
}



        const messages = [
          {    role: 'system',
    content: `Sei un coach motivazionale. Rispondi entro 400 token **e** non troncare mai parole o frasi:  
    • Se rischi di superare il limite, termina la frase corrente con un punto completo.  
    • Assicurati che l'ultima frase si concluda con un punto, un punto esclamativo o un punto interrogativo.`
  },
          { role:'user', content: `${greeting}\n${photoComment}\n${selectComment}\n${diffSummary}\nLinee Guida: ${styleGuide}` }
        ];
        const res = await fetch(generateCommentUrl, { method:'POST', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify({ messages, maxTokens:400 }) });
        const raw = await res.text();
        let data;
        try { data = raw ? JSON.parse(raw) : {}; } catch (e) { throw new Error('Risposta non valida dal server'); }
        if(!res.ok || data.error) throw new Error(data.error || 'Errore nella generazione del commento.');
        let text = (data.comment || '').trim();
        text = text.replace(/\bfitness\b/gi,'percorso');
        checkText.value = completeSentence(text);
      } catch (e) {
        console.error(e);
        alert('Errore nella generazione del commento.');
      } finally { isGenerating.value = false; }
    }

    // Handlers immagini
    const onDrop = (ev, img, prev) => { ev.preventDefault(); const f = ev.dataTransfer.files[0]; if(f){ img.value=f; prev.value=URL.createObjectURL(f); } };
    const onSelect = (ev, img, prev) => { const f=ev.target.files[0]; if(f){ img.value=f; prev.value=URL.createObjectURL(f);} };
    const triggerFileInput = side => {
      const map={one:fileInputOne,two:fileInputTwo,three:fileInputThree,four:fileInputFour};
      map[side]?.value.click();
    };


async function saveCheck() {
  try {
    isLoading.value = true;

    // 1) Parsing delle misurazioni
    const m1 = parseMeasurementData(measurementOneRaw.value);
    const m2 = parseMeasurementData(measurementTwoRaw.value);

    // 2) Upload immagini su Firebase Storage
    const storage = getStorage();
    const upload = async img => {
      if (!img) return '';
      const suffix = Math.floor(Math.random() * 1e6);
      const ref = storageRef(storage, `check/${props.userId}/${suffix}_${img.name}`);
      await uploadBytes(ref, img);
      return await getDownloadURL(ref);
    };
    const imageOneUrl   = await upload(imageOne.value);
    const imageTwoUrl   = await upload(imageTwo.value);
    const imageThreeUrl = await upload(imageThree.value);
    const imageFourUrl  = await upload(imageFour.value);

    // 3) Scrittura su Firestore
    const db = getFirestore();
    const timestamp = serverTimestamp();
    const creationMode = checkType.value === 'baseline' ? 'manual_baseline' : 'manual';
    const isBaselineEntry = checkType.value === 'baseline';

    await addDoc(collection(db, 'check'), {
      userId:                props.userId,
      text:                  checkText.value,
      measurementsOne:       m1,
      measurementsTwo:       m2,
      imageOneUrl,
      imageTwoUrl,
      imageThreeUrl,
      imageFourUrl,
      visibilityProfile:     visibilityProfile.value,
      gender:                gender.value,
      ageGroup:              ageGroup.value,
      menopausa:             menopausa.value,
      haSeguito:             haSeguito.value,
      tipoPercorso:          tipoPercorso.value,
      haAvutoProgressi:      haAvutoProgressi.value,
      respectAllenamento:    respectAllenamento.value,
      respectNutrizione:     respectNutrizione.value,
      acquaAssunta:          acquaAssunta.value,
      riposoCorretta:        riposoCorretta.value,
      creationMode,
      isBaseline:            isBaselineEntry,
      linkedQuestionnaireId: null,
      initialQuestionnaireId: null,
      percorsoId:            selectedPercorsoId.value || null,
      stepIndex:             null,
      createdAt:             timestamp,
      updatedAt:             timestamp
    });

    // 4) Rimozione bozza locale
    sessionStorage.removeItem(`checkDraft_${props.userId}`);

    // 5) Feedback e redirect
    alert('Check salvato con successo!');
    router.push(`/user/${props.userId}/check`);

  } catch (e) {
    console.error(e);
    alert('Errore nel salvataggio del check.');
  } finally {
    isLoading.value = false;
  }
}




    return {
      checkText, measurementOneRaw, measurementTwoRaw,
      userWarning,
      percorsi, selectedPercorsoId, checkType, renderPercorsoLabel,
      visibilityProfile, isLoading, isGenerating,
      imageOne, imageTwo, imageThree, imageFour,
      imageOnePreview, imageTwoPreview, imageThreePreview, imageFourPreview,
      fileInputOne, fileInputTwo, fileInputThree, fileInputFour,
      gender, ageGroup, menopausa, haSeguito, tipoPercorso, haAvutoProgressi,
      respectAllenamento, respectNutrizione, acquaAssunta, riposoCorretta,
      onDropImageOne: e => onDrop(e, imageOne, imageOnePreview),
      onDropImageTwo: e => onDrop(e, imageTwo, imageTwoPreview),
      onDropImageThree: e => onDrop(e, imageThree, imageThreePreview),
      onDropImageFour: e => onDrop(e, imageFour, imageFourPreview),
      onImageOneSelected: e => onSelect(e, imageOne, imageOnePreview),
      onImageTwoSelected: e => onSelect(e, imageTwo, imageTwoPreview),
      onImageThreeSelected: e => onSelect(e, imageThree, imageThreePreview),
      onImageFourSelected: e => onSelect(e, imageFour, imageFourPreview),
      triggerFileInput, generateComment, saveCheck
    };
  }
};
</script>


<style scoped>
.user-check {
  max-width: 95%;
  padding: 1.5rem;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-top: 27px;
  margin-bottom: 70px;
}

.user-warning {
  background: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
  font-weight: 600;
}

.step {
  margin-bottom: 1.5rem;
}

.step h3 {
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
  color: #333;
}

.upload-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.upload-dropzone {
  flex: 1;
  min-width: 250px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s ease;
}
.upload-dropzone:hover { border-color: #888; }

.preview img {
  max-width: 100%;
  border-radius: 4px;
  margin-top: 0.5rem;
}

.measurement-step {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}
.measurement-step > div { flex: 1; min-width: 250px; }

.user-check label { display: block; margin-bottom: 0.3rem; color: #555; }
.user-check textarea {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 14px;
  resize: vertical;
  font-family: inherit;
  margin-bottom: 1rem;
}

.check-textarea { min-height: 80px; white-space: pre-wrap; }

.visibility-toggle { display: flex; align-items: center; gap: 0.5rem; }

.user-check button {
  padding: 0.6rem 1.2rem;
  background: #28a745;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  width: 100%;
}
.user-check button:disabled { background: #ccc; cursor: not-allowed; }

/* Griglia ordinata per le select */
.select-options {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 2rem;
  margin-bottom: 1rem;
}

/* Stile uniforme per tutte le select con arrow interna */
.select-options select {
  width: 100%;
  padding: 0.5rem;
  padding-right: 2rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #f0f0f0 url("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath fill='%23666' d='M0,0 L5,6 L10,0 Z'/%3E%3C/svg%3E") no-repeat right 0.75rem center;
  background-size: 10px 6px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  margin-bottom: 10px;
}
</style>
